import { useTranslation } from "react-i18next";
import { formatDateTime } from "@/utilities/formatDateTime";

/**
 * Returns the given date in a formatted string.
 *
 * The formatting itself lives in {@link formatDateTime}, so a grid's export formatter — which
 * cannot call a hook — renders the same thing the cell does.
 */
export function useFormattedDate(date?: Date | string) {
  const { i18n } = useTranslation();
  return formatDateTime(date, i18n.language);
}
